module.exports = __webpack_public_path__ + "img/自己紹介.c1e8c0af.jpg";